<template>
  <v-menu offset-y content-class="ag-grid-vmenu-2">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" width="15">
        <v-icon color="secondary">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(item, index) in params.items"
        :key="index"
        @click="handleAction(item.action)"
      >
        <v-icon left :color="item.iconColor">
          {{ item.icon }}
        </v-icon>

        <v-list-item-title>
          {{ item.label }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  methods: {
    handleAction(action) {
      if (typeof action === "function") {
        action(this.params?.data);
      }
    },
  },
};
</script>

<style scoped>
.ag-grid-vmenu-2 {
  border-radius: 4px;
}

.ag-grid-vmenu-2 .v-list {
  min-width: 108px;
  max-height: 180px;
  overflow-y: auto;
}

.ag-grid-vmenu-2 .v-list-item {
  transition: 0.2s;
}

.ag-grid-vmenu-2 .v-list-item:hover {
  background: #f5f5f5;
}
</style>
